module.exports = __webpack_public_path__ + "static/img/unconfirmed.c967044b.png";